export default "__VITE_ASSET__CTbm5CTf__"